module.exports = __webpack_public_path__ + "static/media/acmg-cert-gen-form.4ba35dde.png";